'use strict';
import React, { Component } from 'react';
import CuotasPendientesRow from './CuotasPendientesRow';
import DateMinMask from '../../../../../Common/Components/Mask/DateMinMask';
import MontoMask from '../../../../../Common/Components/Mask/MontoMask';

class TotalCuotasPendientes extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { montoTotales, resumen, data, cuotasPendientesDolares, cuotasPendientesPesos,
            totalCuotasPendientesDolares, totalCuotasPendientesPesos, fechasCierresConsumos, tarjetasCreditoId } = this.props;


        let fechasCierresConsumosHead = fechasCierresConsumos.map((fechaCierre) => {
            return (<th style={{ backgroundColor: "#ebebeb" }} className="th-cierres-ef">
                <DateMinMask fecha={fechaCierre.FechaCierre} />
            </th>);
        });

        let cuotasPendientesPesosRows = [];
        let cuotasPendientesDolaresRows = [];

        tarjetasCreditoId.forEach((tarjetaCreditoId) => {
            const cuponesFiltradosPesos = cuotasPendientesPesos.map((cuotaPendientePesos) => {
                return { NumeroEstablecimiento: cuotaPendientePesos.NumeroEstablecimiento, NumeroCupon: cuotaPendientePesos.NumeroCupon }
            });

            let cuponesPesos = [];
            cuponesFiltradosPesos.forEach((cupon) => {
                if (!cuponesPesos.some(x => x.NumeroCupon == cupon.NumeroCupon && x.NumeroEstablecimiento == cupon.NumeroEstablecimiento)) {
                    cuponesPesos.push(cupon);
                }
            });

            cuponesPesos.forEach((cupon) => {
                const cuotasPendientes = cuotasPendientesPesos.filter(x => x.TarjetaCreditoId == tarjetaCreditoId.TarjetaCreditoId
                    && x.NumeroCupon == cupon.NumeroCupon && x.NumeroEstablecimiento == cupon.NumeroEstablecimiento);

                cuotasPendientes.length > 0 &&
                    cuotasPendientesPesosRows.push(<CuotasPendientesRow
                        cuotasPendientes={cuotasPendientesPesos.filter(x => x.TarjetaCreditoId == tarjetaCreditoId.TarjetaCreditoId
                            && x.NumeroCupon == cupon.NumeroCupon && x.NumeroEstablecimiento == cupon.NumeroEstablecimiento)}
                        moneda={"$"}
                    />)
            });

            const cuponesFiltradosDolares = cuotasPendientesPesos.map((cuotaPendientePesos) => {
                return { NumeroEstablecimiento: cuotaPendientePesos.NumeroEstablecimiento, NumeroCupon: cuotaPendientePesos.NumeroCupon }
            });

            let cuponesDolares = [];
            cuponesFiltradosDolares.forEach((cupon) => {
                if (!cuponesDolares.some(x => x.NumeroCupon == cupon.NumeroCupon && x.NumeroEstablecimiento == cupon.NumeroEstablecimiento)) {
                    cuponesDolares.push(cupon);
                }
            });

            cuponesDolares.forEach((cupon) => {
                const cuotasPendientes = cuotasPendientesDolares.filter(x => x.TarjetaCreditoId == tarjetaCreditoId.TarjetaCreditoId
                    && x.NumeroCupon == cupon.NumeroCupon && x.NumeroEstablecimiento == cupon.NumeroEstablecimiento);

                cuotasPendientes.length > 0 &&
                    cuotasPendientesDolaresRows.push(<CuotasPendientesRow
                        cuotasPendientes={cuotasPendientesDolares.filter(x => x.TarjetaCreditoId == tarjetaCreditoId.TarjetaCreditoId
                            && x.NumeroCupon == cupon.NumeroCupon && x.NumeroEstablecimiento == cupon.NumeroEstablecimiento)}
                        moneda={"U$S"}
                    />)
            });
        });

        return <div className="tarjetas container-fluid">
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th style={{ backgroundColor: "#FFFFFF" }} className="th-cierres-big">
                            <label className="label-primary"></label>
                        </th>

                        <th className="th-cierres-ef col-grey">
                            <label className="label-primary">CIERRE</label>
                        </th>

                        {fechasCierresConsumosHead}

                        <th style={{ backgroundColor: "#ebebeb" }} className="th-cierres-ef">
                            <label className="label-primary">Posteriores</label>
                        </th>

                        <th className="th-cierres-ef-fin col-grey">
                            <label className="label-primary">TOTAL PENDT. DE CONSUMO</label>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {cuotasPendientesPesosRows}
                    {cuotasPendientesDolaresRows}
                </tbody>

                <tfoot>
                    <tr>
                        <th className="th-cierres-big">
                            <label className="label-primary"></label>
                        </th>
                        <th className="th-cierres-ef">
                            <label className="label-primary">$</label>
                        </th>
                        <th className="th-cierres-ef lbl-cierres-importe">
                            <MontoMask monto={totalCuotasPendientesPesos.Cierre1} moneda="" />
                        </th>
                        <th className="th-cierres-ef lbl-cierres-importe">
                            <MontoMask monto={totalCuotasPendientesPesos.Cierre2} moneda="" />
                        </th>
                        <th className="th-cierres-ef lbl-cierres-importe">
                            <MontoMask monto={totalCuotasPendientesPesos.Cierre3} moneda="" />
                        </th>
                        <th className="th-cierres-ef lbl-cierres-importe">
                            <MontoMask monto={totalCuotasPendientesPesos.Cierre4} moneda="" />
                        </th>
                        <th className="th-cierres-ef lbl-cierres-importe">
                            <MontoMask monto={totalCuotasPendientesPesos.Cierre5} moneda="" />
                        </th>
                        <th className="th-cierres-ef lbl-cierres-importe">
                            <MontoMask monto={totalCuotasPendientesPesos.TotalPendtConsumo} moneda="" />
                        </th>
                    </tr>

                    <tr>
                        <th className="th-cierres-big">
                            <label className="label-primary"></label>
                        </th>
                        <th className="th-cierres-ef">
                            <label className="label-primary">U$D</label>
                        </th>
                        <th className="th-cierres-ef lbl-cierres-importe">
                            <MontoMask monto={totalCuotasPendientesDolares.Cierre1} moneda="" />
                        </th>
                        <th className="th-cierres-ef lbl-cierres-importe">
                            <MontoMask monto={totalCuotasPendientesDolares.Cierre2} moneda="" />
                        </th>
                        <th className="th-cierres-ef lbl-cierres-importe">
                            <MontoMask monto={totalCuotasPendientesDolares.Cierre3} moneda="" />
                        </th>
                        <th className="th-cierres-ef lbl-cierres-importe">
                            <MontoMask monto={totalCuotasPendientesDolares.Cierre4} moneda="" />
                        </th>
                        <th className="th-cierres-ef lbl-cierres-importe">
                            <MontoMask monto={totalCuotasPendientesDolares.Cierre5} moneda="" />
                        </th>
                        <th className="th-cierres-ef lbl-cierres-importe">
                            <MontoMask monto={totalCuotasPendientesDolares.TotalPendtConsumo} moneda="" />
                        </th>
                    </tr>
                </tfoot>
            </table>
        </div>
    }
}
export default TotalCuotasPendientes;